import { useEffect, useState } from "react";
import { API_BASE_URL } from "../Config/Config";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, Input } from "antd";

export function SignInComponent() {
  const navigate = useNavigate();
  const userDetails =
    JSON.parse(localStorage.getItem("userData")) ||
    JSON.parse(sessionStorage.getItem("userData"));
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const superId = localStorage.getItem("superId");

    if (token && superId) {
      navigate("/profile");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setLoading(true);
    try {
      const response = await axios.post(`${API_BASE_URL}user/login`, {
        username: formData.username,
        password: formData.password,
      });
      const { ResultData } = response?.data;
      const { Token, SuperId } = ResultData;
      if (Token && SuperId) {
        if (rememberMe) {
          localStorage.setItem("authToken", Token);
          localStorage.setItem("userData", JSON.stringify(ResultData));
          localStorage.setItem("superId", SuperId);
        } else {
          sessionStorage.setItem("authToken", Token);
          sessionStorage.setItem("userData", JSON.stringify(ResultData));
          sessionStorage.setItem("superId", SuperId);
        }
        const managerResponse = await axios.get(
          `${API_BASE_URL}team/IsManager?regid=${ResultData?.RegId}`,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          }
        );

        const { ResultData: managerData } = managerResponse.data;

        const isManager = managerData?.[0]?.IsManager || false;
        if (rememberMe) {
          localStorage.setItem("isManager", isManager.toString());
        } else {
          sessionStorage.setItem("isManager", isManager.toString());
        }
        setLoading(false);
        navigate("/profile");
      } else {
        setLoading(false);
        alert("Access denied.");
      }
    } catch (err) {
      console.error("");
      setErrorMessage("");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setErrorMessage("");
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div
      data-kt-name="metronic"
      id="kt_body"
      className="app-blank app-blank bgi-size-cover bgi-position-center bgi-no-repeat"
      style={{ height: "100vh" }}
    >
      <div
        className="d-flex flex-column flex-root"
        id="kt_app_root"
        // style={{ minHeight: "100vh" }}
      >
        <style>
          {`
            body {
              background-image: url('assets/media/auth/bg10.jpeg');
              height: 100%;
            }
            [data-theme="dark"] body {
              background-image: url('assets/media/auth/bg10-dark.jpeg');
            }
          `}
        </style>
        <div
          className="d-flex flex-column flex-lg-row flex-column-fluid"
          style={{ flexGrow: 1 }}
        >
          <div className="d-flex flex-lg-row-fluid">
            <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
              <img
                className="theme-light-show mx-auto mw-100  mb-10 mb-lg-20"
                src="rollcalllogin.png"
                alt=""
              />
              <img
                className="theme-dark-show mx-auto mw-100 w-150px w-lg-300px mb-10 mb-lg-20"
                src="rollcalllogin.png"
                alt=""
              />
              <h1 className="text-gray-800 fs-2qx fw-bold text-center mb-7">
                Fast, Efficient and Productive
              </h1>
            </div>
          </div>

          <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12 py-0">
            <div className="bg-body d-flex flex-center rounded-4 w-md-600px p-10 pt-0">
              <div className="w-md-400px">
                <form
                  className="form w-100"
                  noValidate="novalidate"
                  id="kt_sign_in_form"
                  action="#"
                  onSubmit={handleSubmit}
                >
                  <div className="text-center mb-11">
                    <h1 className="text-dark fw-bolder mb-3">Sign In</h1>
                  </div>

                  <div className="fv-row mb-5">
                    <input
                      type="text"
                      name="username"
                      placeholder="Username"
                      autoComplete="off"
                      value={formData.username}
                      onChange={handleChange}
                      className="form-control bg-transparent"
                    />
                  </div>
                  <Input.Password
                    placeholder="Password"
                    name="password"
                    autoComplete="off"
                    value={formData.password}
                    onChange={handleChange}
                    className="bg-transparent"
                  />
                  <div className="fv-row my-3 p-0 d-flex align-items-center justify-content-end">
                    <input
                      id="rememberMe"
                      type="checkbox"
                      autoComplete="off"
                      checked={rememberMe}
                      onChange={() => setRememberMe((prevState) => !prevState)}
                    />
                    <label htmlFor="rememberMe" className="mx-2">
                      Remember me
                    </label>
                  </div>
                  <p className="text-start text-danger fw-bold">
                    {errorMessage}
                  </p>

                  <div className="d-grid mb-10">
                    <button
                      type="submit"
                      id="kt_sign_in_submit"
                      className="btn btn-primary"
                    >
                      <span className="indicator-progress">
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                      {loading ? (
                        <Spin
                          indicator={
                            <LoadingOutlined spin style={{ color: "white" }} />
                          }
                        />
                      ) : (
                        "Sign In"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div id="carouselExample" className="carousel slide">
        <div className="carousel-inner">
          <div className="carousel-item active">one </div>
          <div className="carousel-item">two </div>
          <div className="carousel-item">
            <img
              alt="Logo"
              src="assets/images/rollcall.jpg"
              style={{ height: "66px", width: "auto", maxWidth: "100%" }}
            />
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExample"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div> */}
      <div className="footer pb-1 d-flex flex-lg-column pt-0" id="kt_footer">
        <div className="container-xxl d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="text-gray-900 order-2 order-md-1">
            <span className="text-muted fw-semibold me-1">2025&copy;</span>
            <a
              href="https://perennialcode.in/"
              target="_blank"
              className="text-gray-800 text-hover-primary"
            >
              Perennial Code
            </a>
          </div>
          <div className="text-gray-900 order-2 order-md-1">
            <span className="text-muted fw-semibold me-1">v 1.0.000</span>
          </div>

          <ul className="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
            <li className="menu-item">
              <a
                href="https://perennialcode.in/"
                target="_blank"
                className="menu-link px-2"
              >
                About
              </a>
            </li>
            <li className="menu-item">
              <a
                href="https://perennialcode.in/"
                target="_blank"
                className="menu-link px-2"
              >
                Support
              </a>
            </li>
            <li className="menu-item">
              <a
                href="https://perennialcode.in/"
                target="_blank"
                className="menu-link px-2"
              >
                Purchase
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
